// Prerendered pages record the route they were rendered for. A static server that falls back to
// another page's HTML for an unknown path would otherwise hand the wrong markup to hydration.
export const normalizePath = (pathname: string) => pathname.replace(/\/+$/, '') || '/';

export function canHydrate(container: HTMLElement, pathname: string) {
  return container.hasChildNodes() && container.dataset.prerenderedPath === normalizePath(pathname);
}

/**
 * Decide whether to hydrate, then remove the route marker. Session Replay accepts only a fixed
 * set of element attributes and drops a whole recording that contains any other, so the marker
 * must be gone before monitoring takes its first snapshot.
 */
export function claimPrerenderedRoot(container: HTMLElement, pathname: string) {
  const hydrate = canHydrate(container, pathname);
  container.removeAttribute('data-prerendered-path');
  return hydrate;
}
